import { Card, CardContent, Typography, Box } from "@mui/material";
import dayjs from "dayjs";

export default function UserCard({ user }) {
    return (
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <CardContent>
                {/* Name */}
                <Typography variant="h6">
                    {user.firstName} {user.lastName}
                </Typography>

                {/* Username & Type */}
                <Typography variant="body2" color="textSecondary">
                    {user.username} | {user.userType}
                </Typography>

                {/* Location */}
                <Typography variant="body2" color="textSecondary">
                    {user.city}, {user.state}, {user.country}
                </Typography>

                {/* Contact */}
                {user.daytimePhone && (
                    <Typography variant="body2" color="textSecondary">
                        Phone: {user.daytimePhone}
                    </Typography>
                )}

                {/* Military Service */}
                {user.militaryService && (
                    <Box mt={1}>
                        <Typography variant="body2">
                            Military Service: {user.militaryServiceBranch} (
                            {dayjs(user.militaryServiceStartDate).format("MMM YYYY")} -{" "}
                            {dayjs(user.militaryServiceEndDate).format("MMM YYYY")})
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}
